var _g, _rect;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconDate(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Calendar",
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icons_Navigation_icon_12_states_",
    "data-name": "Icons / Navigation icon (12 states)",
    transform: "translate(1 1)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "ic-calendar"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_445",
    "data-name": "\\uD328\\uC2A4 445",
    d: "M0,0H21.5V21.5H0Z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "\\uC0AC\\uAC01\\uD615_608",
    "data-name": "\\uC0AC\\uAC01\\uD615 608",
    width: 15,
    height: 15,
    rx: 2,
    transform: "translate(3 3.85)",
    fill: "none",
    stroke: "#c3c8c8",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("line", {
    id: "\\uC120_31",
    "data-name": "\\uC120 31",
    y2: 5,
    transform: "translate(14 2)",
    fill: "none",
    stroke: "#c3c8c8",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("line", {
    id: "\\uC120_32",
    "data-name": "\\uC120 32",
    y2: 5,
    transform: "translate(7 2)",
    fill: "none",
    stroke: "#c3c8c8",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("line", {
    id: "\\uC120_33",
    "data-name": "\\uC120 33",
    x2: 15,
    transform: "translate(3 9.931)",
    fill: "none",
    stroke: "#c3c8c8",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("rect", {
    id: "\\uC0AC\\uAC01\\uD615_609",
    "data-name": "\\uC0AC\\uAC01\\uD615 609",
    width: 2,
    height: 2,
    transform: "translate(7 12.901)",
    fill: "#c3c8c8"
  })))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "\\uC0AC\\uAC01\\uD615_2473",
    "data-name": "\\uC0AC\\uAC01\\uD615 2473",
    width: 24,
    height: 24,
    fill: "none"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconDate);
export default __webpack_public_path__ + "static/media/iconDate.421ea256353e6fd2c4c3390b02bcd224.svg";
export { ForwardRef as ReactComponent };